<template>
    <div>
        <el-row class="cs-contentContainer">
            <el-col :span="4" class="cs-main-left-container">
                <navigator></navigator>
            </el-col>
            <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
                <div class="cs-fullHeight cs-contentContainer-right">
                    <div class="backgroud-white  cs-contentContainer-right-content cs-fullHeight">
                        <el-row>
                            <span class="cs-title">作业详情</span>
                            <el-row class="grid-content">
                                <el-row>
                                    <el-col :span="20">
                                        <breadcrumbNavigationBar :data="homeworkNavigationBarData"></breadcrumbNavigationBar>
                                    </el-col>
                                    <el-col :span="4" class="text-right">
                                        <el-button v-if="!USERMANAGER.isStudent" type="primary" @click="onAdd">添加新作业</el-button>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <pagination v-loading="loading" :data="homeworkList" :option="paginationOption" @customEvent="customEventHandler"></pagination>
                                </el-row>

                            </el-row>

                        </el-row>
                    </div>
                </div>
            </el-col>
        </el-row>
        <el-dialog :close-on-click-modal="false" width="600px" :visible.sync="dialogEditorVisible" top="8vh">
            <homeworkEditor :data="editData" @closeDialog="onCloseEditor" @saveSuccess="onSaveSuccess"></homeworkEditor>
        </el-dialog>
    </div>
</template>

<style lang="scss" scoped>
/deep/ body .el-table .el-table-header th {
    height: 30px;
    padding: 5px 0px;
    color: #909399 !important;
    background-color: #FFF !important;
}

.cs-contentContainer {
    .grid-content {
        margin-top: 15px;
        /deep/ .el-table .el-table-header th {
            height: 30px;
            padding: 5px 0px;
            color: #909399 !important;
            background-color: #FFF !important;
        }
    }
}
</style>

<script>
import navigator from "../../components/navigator";
import pagination from "../../components/common/pagination";
import homeworkEditor from "../../components/homework/homeworkEditor";
import breadcrumbNavigationBar from "../../components/common/breadcrumbNavigationBar";
import { getCourseHomeWorkDetailList, removeHomework } from "../../service/homework.service";
import { getStore, setStore } from "../../config/mUtils";
import global_ from "../../core/global";
let moment = require("moment");

export default {
    data() {
        return {
            loading: false,
            paginationOption: {},
            editData: {},
            dialogEditorVisible: false,
            courseType: 1,
            courseId: 0,
            campusId: 0,
            courseName: "",
            courseActivations: [],
            homeworkList: [],
            homeworkNavigationBarData: {},
        };
    },
    components: {
        navigator,
        pagination,
        homeworkEditor,
        breadcrumbNavigationBar
    },
    computed: {

    },
    created() {
        this.paginationOption = {
            displayPagination: false,
            hasEditButton: false,
            hasAddButton: false,
            addButtonText: "",
            hasSearch: false,
            showAcitveColor: true,
            hideDisableRow: true,
            isStudent: this.USERMANAGER.isStudent,
            isNotStudent: !this.USERMANAGER.isStudent
        };

        this.courseId = Number(this.$route.query.courseId);
        this.campusId = Number(this.$route.query.campusId);
        this.courseName = this.$route.query.courseName;
        this.courseType = Number(this.$route.query.courseType);
        this.loadData();
    },
    methods: {
        loadData() {
            this.loading = true;
            getCourseHomeWorkDetailList(this.courseId, this.campusId).then(result => {
                if (!!result && result.success) {
                    this.homeworkList = result.data;
                }
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            });
            this.buildNavigations();
        },
        buildNavigations() {
            this.homeworkNavigationBarData = {
                name: '作业管理',
                navList: [],
                currentName: this.courseName
            }
            let link = "/homeworkManage?courseType=" + this.courseType
            if (this.courseType == 1) {

                this.homeworkNavigationBarData.navList.push({ link: link, name: '大学补习' });
            } else if (this.courseType == 2) {
                this.homeworkNavigationBarData.navList.push({ link: link, name: '应试英语' });
            } else {
                this.homeworkNavigationBarData.navList.push({ link: link, name: '职业培训' });
            }
        },
        nav(data) {
            if (this.USERMANAGER.isStudent) {
                this.$router.push({
                    path: "/studentHomeworkDetail",
                    query: {
                        homeworkId: data.Id,
                    }
                });
            } else {
                this.$router.push({
                    path: "/homeworkStudentList",
                    query: {
                        courseType: this.courseType,
                        courseId: data.CourseId,
                        campusId: data.CampusId,
                        courseName: this.courseName,
                        homeworkId: data.Id,
                        homeworkName: data.Name,
                    }
                });
            }
        },
        onAdd() {
            this.editData = {};
            this.editData.CourseName = this.courseName;
            this.editData.CourseId = this.courseId;
            this.editData.CampusId = this.campusId;
            this.dialogEditorVisible = true;
        },
        editHomework(data) {
            this.editData = data;
            this.dialogEditorVisible = true;
        },
        deleteHomework(data) {
            this.$confirm("您确定要删除作业吗?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    removeHomework(data.Id).then(
                        result => {
                            if (!!result && result.success) {
                                this.loadData();
                            } else {
                                this.$message.error(result.message);
                            }
                        }
                    )
                })
                .catch(() => {});
        },
        dateFormat(date) {
            var m = moment(date);
            if (m.isValid()) {
                return moment(date).format('YYYY/MM/DD HH:mm A');
            } else {
                return "";
            }

        },
        onCloseEditor() {
            this.dialogEditorVisible = false;
        },
        onSaveSuccess(isAdd, row) {
            this.dialogEditorVisible = false;
            this.loadData();
        },
        customEventHandler(data) {
            if (data.action == 'editHomework') {
                this.editHomework(data.data);
            } else if (data.action == 'deleteHomework') {
                this.deleteHomework(data.data);
            } else if (data.action == 'nav') {
                this.nav(data.data);
            }
        },

    }
};
</script>



// WEBPACK FOOTER //
// src/page/homework/homeworkList.vue